module.exports = __webpack_public_path__ + "img/34.89383d12.jpg";